var _path, _path2, _g, _use, _use2, _use3, _circle, _path3, _use4, _use5, _use6, _use7, _path4, _path5, _path6, _path7, _path8, _path9, _use8, _circle2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAr = function SvgAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#74acdf",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 160h640v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ar_svg__c",
    transform: "translate(-64)scale(.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__a",
    fill: "#f6b40e",
    stroke: "#85340a",
    strokeWidth: 1.1,
    d: "m396.8 251.3 28.5 62s.5 1.2 1.3.9c.8-.4.3-1.6.3-1.6l-23.7-64m-.7 24.2c-.4 9.4 5.4 14.6 4.7 23s3.8 13.2 5 16.5c1 3.3-1.2 5.2-.3 5.7 1 .5 3-2.1 2.4-6.8s-4.2-6-3.4-16.3-4.2-12.7-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__a",
    width: "100%",
    height: "100%",
    transform: "rotate(22.5 400 250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__a",
    width: "100%",
    height: "100%",
    transform: "rotate(45 400 250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__a",
    width: "100%",
    height: "100%",
    transform: "rotate(67.5 400 250)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__b",
    fill: "#85340a",
    d: "M404.3 274.4c.5 9 5.6 13 4.6 21.3 2.2-6.5-3.1-11.6-2.8-21.2m-7.7-23.8 19.5 42.6-16.3-43.9"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(22.5 400 250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(45 400 250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(67.5 400 250)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__c",
    width: "100%",
    height: "100%",
    transform: "rotate(90 320 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__c",
    width: "100%",
    height: "100%",
    transform: "rotate(180 320 240)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__c",
    width: "100%",
    height: "100%",
    transform: "rotate(-90 320 240)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 26.7,
    fill: "#f6b40e",
    stroke: "#85340a",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__h",
    fill: "#843511",
    strokeWidth: 1,
    d: "M329 234.3c-1.7 0-3.5.8-4.5 2.4 2 1.9 6.6 2 9.7-.2a7 7 0 0 0-5.1-2.2zm0 .4c1.8 0 3.5.8 3.7 1.6-2 2.3-5.3 2-7.4.4q1.6-2 3.8-2z"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__d",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 640.2 0)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__e",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 640.2 0)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__f",
    width: "100%",
    height: "100%",
    transform: "translate(18.1)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__g",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 640.2 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M316 243.7a1.8 1.8 0 1 0 1.8 2.9 4 4 0 0 0 2.2.6h.2q1 0 2.3-.6.5.7 1.5.7a1.8 1.8 0 0 0 .3-3.6q.8.3.8 1.2a1.2 1.2 0 0 1-2.4 0 3 3 0 0 1-2.6 1.7 3 3 0 0 1-2.5-1.7q-.1 1.1-1.3 1.2-1-.1-1.2-1.2c-.2-1.1.3-1 .8-1.2zm2 5.4c-2.1 0-3 2-4.8 3.1 1-.4 1.8-1.2 3.3-2s2.6.2 3.5.2 2-1 3.5-.2q2 1.3 3.3 2c-1.9-1.2-2.7-3-4.8-3q-.7 0-2 .6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M317.2 251.6q-1.1 0-3.4.6c3.7-.8 4.5.5 6.2.5 1.6 0 2.5-1.3 6.1-.5-4-1.2-4.9-.4-6.1-.4-.8 0-1.4-.3-2.8-.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M314 252.2h-.8c4.3.5 2.3 3 6.8 3s2.5-2.5 6.8-3c-4.5-.4-3.1 2.3-6.8 2.3-3.5 0-2.4-2.3-6-2.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#85340a",
    d: "M323.7 258.9a3.7 3.7 0 0 0-7.4 0 3.8 3.8 0 0 1 7.4 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__e",
    fill: "#85340a",
    strokeWidth: 1,
    d: "M303.4 234.3c4.7-4.1 10.7-4.8 14-1.7a8 8 0 0 1 1.5 3.4q.6 3.6-2.1 7.5l.8.4q2.4-4.7 1.6-9.4l-.6-2.3c-4.5-3.7-10.7-4-15.2 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__d",
    fill: "#85340a",
    strokeWidth: 1,
    d: "M310.8 233c2.7 0 3.3.6 4.5 1.7 1.2 1 1.9.8 2 1 .3.2 0 .8-.3.6q-.7-.2-2.5-1.6c-1.8-1.4-2.5-1-3.7-1-3.7 0-5.7 3-6.1 2.8-.5-.2 2-3.5 6.1-3.5"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ar_svg__h",
    width: "100%",
    height: "100%",
    transform: "translate(-18.4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "ar_svg__f",
    cx: 310.9,
    cy: 236.3,
    r: 1.8,
    fill: "#85340a",
    strokeWidth: 1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "ar_svg__g",
    fill: "#85340a",
    strokeWidth: 1,
    d: "M305.9 237.5c3.5 2.7 7 2.5 9 1.3 2-1.3 2-1.7 1.6-1.7s-.8.4-2.4 1.3c-1.7.8-4.1.8-8.2-.9"
  })));
};
export default SvgAr;